var $windowTop = $(window).scrollTop();
var $clickEventType = window.ontouchstart !== null ? "click" : "touchstart";
var $body = $("body");
var $break = "(max-width:767px)";
var $pc = "(min-width:768px)";

window.onload = function () {
	var brandProductSlider = new Swiper(".js-brand-products", {
		slidesPerView: 1.5,
		spaceBetween: 20,
		speed: 500,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			768: {
				simulateTouch: false,
				allowTouchMove: false,
				slidesPerView: 3,
				loopAdditionalSlides: 0,
				preventInteractionOnTransition: true,
				observer: true,
				observeParents: true,
			},
			1080: {
				slidesPerView: 4,
			},
		},
	});

	var brandProductDetailThumbsSlider = new Swiper(".js-brand-detail-thumb-slider", {
		slidesPerView: 6,
		spaceBetween: 7,
		loop: false,
		loopAdditionalSlides: 0,
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		speed: 500,
		slideToClickedSlide: true,
		breakpoints: {
			1024: {
				spaceBetween: 10,
			},
		},
	});

	var brandProductDetailSlider = new Swiper(".js-brand-detail-slider", {
		simulateTouch: false,
		allowTouchMove: false,
		slidesPerView: 1,
		spaceBetween: 0,
		loopAdditionalSlides: 0,
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		speed: 500,
		thumbs: {
			swiper: brandProductDetailThumbsSlider,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

	fpCategorySlider();
	fpProductsSpecialSlider();
	fpProductsCategorySlider();
	fpVisualSlider();
};

$(function () {
	cartBtn();
	headerNav();
	headerNavAccordion();
	spinner();
	searchModal();

	if (window.matchMedia($break).matches) {
		topicPathWidth();
		guideAccordion();
	}

	headerHeight();

	$(window).scroll(function () {
		headerHeight();
	});
});

function cartBtn() {
	const $b = $(".js-cart-btn");
	const $c = $(".js-cart-cont");
	const $close = $(".js-cart-close");

	$b.on($clickEventType, function () {
		$c.toggleClass("is-show");
		return false;
	});

	$close.on($clickEventType, function () {
		$c.removeClass("is-show");
		return false;
	});

	var $windowTop = $(window).scrollTop();
	var $h = $(".js-header-height").height();

	var $headerHeightInit = "90";

	if ($windowTop < 1) {
		$c.css("padding-top", $headerHeightInit + "px");
	} else {
		$c.css("padding-top", $h + "px");
	}

	$(window).scroll(function () {
		var $windowTop = $(window).scrollTop();
		var $h = $(".js-header-height").height();

		if ($windowTop < 1) {
			$c.css("padding-top", "90px");
		} else {
			$c.css("padding-top", $h + "px");
		}
	});
}

function headerNav() {
	const $b = $(".js-header-nav__btn");
	const $c = $(".js-header-nav");
	const $bg = $(".js-header-nav__bg");

	$b.on($clickEventType, function () {
		$b.toggleClass("is-active");
		$c.toggleClass("is-show");
		$bg.toggleClass("is-show");
		$body.toggleClass("js-header-nav-show");
		return false;
	});
}

function headerNavAccordion() {
	const $b = $(".js-header-nav-acc");

	$b.on($clickEventType, function () {
		$(this).toggleClass("is-active");
		$(this).next(".js-header-nav-acc-inner").toggleClass("is-show");
	});
}

function topicPathWidth() {
	var $widthList = new Array();
	$(".topic-path__list__item").each(function (index) {
		$widthList[index] = $(this).outerWidth();
	});
	var $widthSum = $widthList.reduce((sum, num) => sum + num, 0) + 20;
	$(".topic-path__list").css({ width: $widthSum });
	//console.log($widthSum);
}

function headerHeight() {
	var $windowTop = $(window).scrollTop();
	if ($windowTop > 0) {
		$(".js-header-height").addClass("is-active");
	} else {
		$(".js-header-height").removeClass("is-active");
	}
}

function guideAccordion() {
	const $b = $(".js-guide-acc");
	if (!$b) return;

	$b.on($clickEventType, function () {
		$(this).toggleClass("is-active");
		$(this).next(".js-guide-acc-cont").toggleClass("is-show");
		return false;
	});
}

function fpCategorySlider() {
	const $q = $(".js-fp-category-slider");
	if (!$q) return;

	var swiper = new Swiper(".js-fp-category-slider", {
		simulateTouch: false,
		allowTouchMove: false,
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		loopAdditionalSlides: 0,
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		speed: 500,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	});
}

function fpProductsSpecialSlider() {
	const $q = $(".js-products-special-slider");
	if (!$q) return;

	var swiper = new Swiper(".js-products-special-slider", {
		slidesPerView: 1.3,
		spaceBetween: 15,
		speed: 500,
		loop: true,
		loopAdditionalSlides: 1,
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		centeredSlides: true,
		autoplay: {
			delay: 3000,
		},
		breakpoints: {
			768: {
				spaceBetween: 25,
			},
			1023: {
				slidesPerView: 1.5,
			},
		},
	});
}

function fpProductsCategorySlider() {
	const $q = $(".js-products-category-slider");
	if (!$q) return;

	var swiper = new Swiper(".js-products-category-slider", {
		slidesPerView: 1.5,
		spaceBetween: 20,
		speed: 500,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			768: {
				simulateTouch: false,
				allowTouchMove: false,
				slidesPerView: 3,
				loopAdditionalSlides: 0,
				preventInteractionOnTransition: true,
				observer: true,
				observeParents: true,
			},
			1080: {
				slidesPerView: 4,
			},
		},
	});
}

function fpProductsSpecialSlider() {
	const $q = $(".js-products-special-slider");
	if (!$q) return;

	var swiper = new Swiper(".js-products-special-slider", {
		slidesPerView: 1.3,
		spaceBetween: 15,
		speed: 500,
		loop: true,
		loopAdditionalSlides: 1,
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		centeredSlides: true,
		autoplay: {
			delay: 3000,
		},
		breakpoints: {
			768: {
				spaceBetween: 25,
			},
			1023: {
				slidesPerView: 1.5,
			},
		},
	});
}

function fpVisualSlider() {
	const $q = $(".js-fp-visual-slider");
	if (!$q) return;

	var swiper = new Swiper(".js-fp-visual-slider", {
		slidesPerView: 1,
		speed: 2000,
		autoplay: {
			delay: 1000,
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
	});
}

function spinner() {
	const $spinner = $(".js-spinner");
	if (!$spinner.length > 0) return;

	$spinner.each(function () {
		var el = $(this);
		var sub = $(".js-spinner-minus");
		var add = $(".js-spinner-plus");

		// substract
		el.parent().off("click", ".js-spinner-minus");
		el.parent().on("click", ".js-spinner-minus", function () {
			if (el.val() > parseInt(el.attr("min"))) {
				el.val(function (i, oldval) {
					return --oldval;
				});
			}
			// disabled
			if (el.val() == parseInt(el.attr("min"))) {
				el.prev(sub).addClass("is-disabled");
			}
			if (el.val() < parseInt(el.attr("max"))) {
				el.next(add).removeClass("is-disabled");
			}
		});

		// increment
		el.parent().off("click", ".js-spinner-plus");
		el.parent().on("click", ".js-spinner-plus", function () {
			if (el.val() < parseInt(el.attr("max"))) {
				el.val(function (i, oldval) {
					return ++oldval;
				});
			}
			// disabled
			if (el.val() > parseInt(el.attr("min"))) {
				el.prev(sub).removeClass("is-disabled");
			}
			if (el.val() == parseInt(el.attr("max"))) {
				el.next(add).addClass("is-disabled");
			}
		});
	});
}

function searchModal() {
	const $b = $(".js-search-modal-btn");
	const $c = $(".js-search-modal");
	const $close = $(".js-search-modal-close");
	const $cont = $(".js-search-modal-tab-cont");

	$cont.addClass("is-show");

	$b.on($clickEventType, function () {
		$c.toggleClass("is-show");
		return false;
	});

	$close.on($clickEventType, function () {
		$c.removeClass("is-show");
		return false;
	});

	const $tab = $(".js-search-modal-tab");

	$tab.each(function (index) {
		$(this).on($clickEventType, function () {
			$tab.removeClass("is-cur");
			$(this).addClass("is-cur");

			$cont.removeClass("is-show");

			if (index === 0) {
				$cont.addClass("is-show");
				$('#searchResult .m-card.meika').show();
				$('#searchResult .m-card.other').show();

			}else if(index == 1){
				$('#searchResult .m-card.meika').show();
				$('#searchResult .m-card.other').hide();

			}else if(index == 2) {
				$('#searchResult .m-card.meika').hide();
				$('#searchResult .m-card.other').show();

			}

			$cont.eq(index - 1).addClass("is-show");
			return false;
		});
	});
}
